<template>
  <div>
    <el-form :inline="true" :model="formInline" size="mini" class="user-search">
      <el-form-item v-model="formInline">
        <el-cascader
          ref="cascader"
          size="mini"
          :placeholder="$t('deviceControl.operatorId')"
          filterable
          :options="operatorsTree"
          :show-all-levels="false"
          @change="handChangeOperator"
          :props="{ checkStrictly: true, expandTrigger: 'hover' }"
          v-model="operatorIds"
          clearable
        >
        </el-cascader>
      </el-form-item>

      <el-form-item label="" prop="stationCode">
        <el-select
          size="mini"
          clearable
          filterable
          v-model="formInline.t.stationCode"
          :placeholder="$t('alaramMonitor.site')"
          style="width: 130px"
        >
          <el-option
            v-for="item in searchData.stations"
            :key="item.id"
            :label="item.stationName"
            :value="item.stationCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          type="datetime"
          size="mini"
          v-model="formInline.t.beginTime"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('kai-shi-ri-qi')"
          style="width: 175px"
        ></el-date-picker>
        <span>{{ $t('deviceControl.to') }}</span>
        <el-date-picker
          type="datetime"
          size="mini"
          v-model="formInline.t.endTime"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('jie-shu-ri-qi')"
          style="width: 175px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="" prop="orderState">
        <el-select
          size="mini"
          clearable
          v-model="formInline.t.orderState"
          :placeholder="$t('ding-dan-zhuang-tai')"
        >
          <el-option
            v-for="item in searchData.orderState"
            :key="item.value"
            :label="item.message"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="electricityUp">
        <el-select
          size="mini"
          clearable
          v-model="formInline.t.electricityUp"
          :placeholder="$t('ding-dan-dian-liang')"
        >
          <el-option
            v-for="item in searchData.electricityUp"
            :key="item.value"
            :label="item.message"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          clearable
          size="mini"
          v-model="formInline.t.phone"
          :placeholder="$t('shou-ji-hao-0')"
          style="width: 130px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          clearable
          size="mini"
          v-model="formInline.t.companyCode"
          :placeholder="$t('di-san-fang-ping-tai-zu-zhi-ji-gou-dai-ma')"
          style="width: 130px"
        ></el-input>
      </el-form-item>
      <!--<el-form-item label="">-->
      <!--<el-input size="mini" v-model="formInline.t.cardNo" placeholder="请输入卡号" clearable></el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="" prop="payType">
        <el-select
          size="mini"
          clearable
          v-model="formInline.t.payType"
          :placeholder="$t('fu-fei-fang-shi')"
          style="width: 130px"
        >
          <el-option
            v-for="item in searchData.payTypes"
            :key="item.value"
            :label="item.message"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm"
          >{{ $t('deviceControl.empty') }}</el-button
        >
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >{{ $t('deviceControl.search') }}</el-button
        >
        <el-button
          v-if="checkPermission(['bee:order:chargingRequest:excel'])"
          type="primary"
          icon="el-icon-download"
          :loading="exportLoading"
          @click="exportData"
          >{{ $t('excel-dao-chu') }}</el-button
        >
      </el-form-item>
      <!--列表-->
      <el-table
        size="mini"
        @selection-change="selectChange"
        :data="chongdiangmingxi"
        highlight-current-row
        v-loading="loading"
        border
        :element-loading-text="$t('paramMonitor.Loading')"
        style="width: 100%"
      >
        <af-table-column
          prop="operatorId"
          :formatter="formatOperator"
          :label="$t('deviceControl.operatorId')"
        >
        </af-table-column>
        <af-table-column align="center" prop="stationName" :label="$t('siteMonitor.stationName')">
        </af-table-column>
        <!--<af-table-column align="center" prop="pileCode" label="桩号" width="140">-->
        <!--</af-table-column>-->
        <af-table-column align="center" prop="gunCode" :label="$t('chargingMonitor.GunNumber')">
          <!--</af-table-column>-->
          <!--<af-table-column prop="dataFrom.message" label="启动方式">-->
        </af-table-column>
        <af-table-column align="center" prop="phone" :label="$t('shou-ji-hao-0')">
        </af-table-column>
        <!--<af-table-column align="center" prop="cardNo" label="卡号" width="140">-->
        <!--</af-table-column>-->
        <af-table-column prop="chargeBegTime" :label="$t('kai-shi-shi-jian')">
        </af-table-column>
        <af-table-column
          align="center"
          prop="chargeEndTime"
          :label="$t('jie-shu-chong-dian-shi-jian')"
        >
        </af-table-column>
        <af-table-column
          align="center"
          prop="chargeTotalElectricity"
          :label="$t('dian-liang-0')"
          width="80"
        >
        </af-table-column>
        <af-table-column
          align="center"
          prop="fee"
          :label="$t('zong-jin-e')"
          width="90"
        >
        </af-table-column>
        <af-table-column
          align="center"
          prop="electricityFee"
          :label="$t('zong-chong-dian-fei-yong')"
          width="90"
        >
        </af-table-column>
        <af-table-column
          align="center"
          prop="serviceFee"
          :label="$t('fu-wu-fei-jin-e')"
          width="90"
        >
        </af-table-column>
        <af-table-column prop="state.message" :label="$t('ding-dan-zhuang-tai-0')" width="80">
        </af-table-column>
        <af-table-column prop="payType" :label="$t('zhi-fu-fang-shi')"> </af-table-column>
        <af-table-column prop="plateNo" :label="$t('che-pai-hao')"> </af-table-column>
      </el-table>
      <Pagination
        v-bind:child-msg="pageparm"
        @callFather="callFather"
      ></Pagination>
      <!--</el-tabs>-->
    </el-form>
  </div>
</template>

<script>
import Pagination from "@/module/cardManage/component/Pagination.vue";
import commonApi from "@/common/api/commonFromVuexApi.js";
import api from "@/module/possessionCenter/api/order.js";
import enumApi from "@/common/api/enumFromVuexApi.js";
import report from "@/module/dataCenter/api/report.js";
import axios from "axios";
import comApi from "@/common/api/commonApi.js";

export default {
  name: "list",
  data() {
    return {
      operatorIds: [],
      operatorsTree: [],
      tabPosition: "left",
      chart: null,
      loading: false,
      exportLoading: false,
      chongdiangmingxi: [],
      // 列表数据
      userData: [],
      // 选择数据
      selectdata: [],
      // 表单查询条件
      searchData: {
        // 订单状态
        orderState: [],
        // 运营商
        operators: [],
        // z站点
        stations: [],
        //电量是否大于0
        electricityUp: [
          { value: 1, message: this.$t('dian-liang-da-yu-ling-de-ding-dan') },
          { value: 2, message: this.$t('dian-liang-wei-ling-de-ding-dan') },
        ],
      },
      // rules表单验证
      rules: {
        userSex: [{ required: true, message: "", trigger: "blur" }],
      },
      // 分页
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      // 请求数据参数
      formInline: {
        t: {
          beginTime: null,
          endTime: null,
          gunNo: "",
          cardNo: "",
          chargeOrderNo: "",
          payType: "",
          orderState: null,
          electricityUp: 1,
          phone: "",
          stationCode: "",
          opeartorId: "",
          companyCode: ""
        },
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: this.$t('jin-tian'),
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: this.$t('zuo-tian'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: this.$t('yi-zhou-qian'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.getOperators();
    this.getOperatorsTree();
    this.getOrderStatus();
    this.getPaymentType();
    this.search();
  },
  methods: {
    //获取运营商树
    getOperatorsTree() {
      let params = JSON.stringify({});
      comApi.getOperatorsTree(params).then((res) => {
        this.operatorsTree = res.data;
      });
    },
    handChangeOperator(value) {
      let operatorId = value && value.length > 0 ? value[value.length - 1] : "";
      this.formInline.t.opeartorId = operatorId;
      report.stationList([operatorId]).then((res) => {
        this.searchData.stations = res.data;
      });
      this.$refs.cascader.dropDownVisible = false;
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val;
    },
    // 根据运营商id匹配名字
    formatOperator: function (row, column) {
      let obj = this.searchData.operators.find((item) => {
        return item.id === row.operatorId;
      });
      if (obj != null && obj !== undefined) {
        return obj.name;
      } else {
        return row.operatorId;
      }
    },
    // 获取支付方式
    getPaymentType() {
      enumApi.getPaymentType().then((res) => {
        // console.log('获取到的支付方式是:{}',JSON.stringify(res))
        this.searchData.payTypes = res;
      });
    },
    // 获取订单状态
    getOrderStatus() {
      enumApi.getOrderStatus().then((res) => {
        this.searchData.orderState = res;
      });
    },
    // 站点
    operatorSelect() {
      report.stationList([this.formInline.t.opeartorId]).then((res) => {
        this.searchData.stations = res.data;
      });
    },
    // 获取运营商
    getOperators() {
      commonApi.getOperators().then((res) => {
        this.searchData.operators = res;
      });
    },
    // 分页插件事件
    callFather() {
      let data = {
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        t: this.formInline.t,
      };
      this.getData(data);
    },
    resetSearchForm() {
      this.formInline.t = {};
      this.operatorIds = [];
      this.search();
    },
    // 搜索事件
    search() {
      this.getData(this.formInline);
    },
    getData(parameter) {
    	if(parameter.t.beginTime == null
          && parameter.t.endTime == null
          && parameter.t.gunNo  == ''
          && parameter.t.cardNo  == ''
          && parameter.t.chargeOrderNo  == ''
          && parameter.t.payType  == ''
          && parameter.t.orderState  == null
          && parameter.t.phone  == ''
          && parameter.t.stationCode  == ''
          && parameter.t.opeartorId  == ''){
          this.$message({
            showClose:true,
            message:this.$t('qing-zhi-shao-xuan-ze-huo-shu-ru-yi-ge-cha-xia-tiao-jian'),
            type:"error"
          })
          return;
        }
      this.loading = true;
      report.getOrderReport(JSON.stringify(parameter))
        .then((res) => {
          this.chongdiangmingxi = res.data.list;
          // 分页赋值
          this.pageparm.currentPage = res.data.pageNum;
          this.pageparm.total = res.data.total;
          // 加载结束
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    async exportData() {
      console.log("导出");
      let flag = false;
      this.exportLoading =  true;
      if (
        this.formInline.t.beginTime == null ||
        this.formInline.t.endTime == null ||
        this.formInline.t.beginTime == "" ||
        this.formInline.t.endTime == ""
      ) {
        flag = false;
      } else {
        let beginDate = new Date(this.formInline.t.beginTime.substring(0, 10));
        let endDate = new Date(this.formInline.t.endTime.substring(0, 10));
        let diffYear = endDate.getFullYear() - beginDate.getFullYear();
        let diffMonth =
          diffYear * 12 + endDate.getMonth() - beginDate.getMonth();
        let diffDay = endDate.getDate() - beginDate.getDate();
        if (diffMonth < 3 || (diffMonth == 3 && diffDay <= 0)) {
          flag = true;
        }
      }
      if (flag) {
        let param = {
          orderState: this.formInline.t.orderState,
          electricityUp: this.formInline.t.electricityUp,
          opeartorId: this.formInline.t.opeartorId,
          stationCode: this.formInline.t.stationCode,
          companyCode: this.formInline.t.companyCode,
          payType: this.formInline.t.payType,
          phone: this.formInline.t.phone,
          beginTime:
            this.formInline.t.beginTime === null
              ? ""
              : this.formInline.t.beginTime,
          endTime:
            this.formInline.t.endTime === null
              ? ""
              : this.formInline.t.endTime,
        };
        report.downloadOrder(param).then((res) => {
          if (res) {
            this.downloadExcel(res, this.$t('ding-dan-liu-shui'));
            this.exportLoading =  false;
          }else{
            this.exportLoading =  false;
          }
        });
      } else {
        this.exportLoading =  false;
        //订单报表
        this.$message.error(this.$t('qing-xuan-ze-3-ge-yue-zhi-nei-shu-ju-dao-chu'));
      }
    },
    //下载excel,res为要导出的内容，name为文件名
    downloadExcel(res, name) {
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      // 创建一个超链接a标签
      const downloadElement = document.createElement("a");
      const href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      downloadElement.download = name + ".xlsx";
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/baobiao/mingxi/list.vue